export enum ClientPaymentMethods {
  directDebit = 1,
  bankTransfer = 2,
  card = 3,
}

export const paymentMethods = Object.entries(ClientPaymentMethods)
  .filter(([key, value]) => typeof value === 'number')
  .map(([key, value]) => ({
    label: key,
    value: value as number,
  }));

export enum ContactTypeEnum {
  default = 0,
  billing = 1,
  fleet = 2,
  operations = 3,
}

export const contactDepartmentsTypeOptions = Object.entries(ContactTypeEnum)
  .filter(([key, value]) => typeof value === 'number')
  .map(([key, value]) => ({
    label: key,
    value: value as number,
  }));

enum ClientTypeEnum {
  Dealership = 0,
  Workshop = 1,
  Renting = 2,
  RaC = 3,
  Insurer = 4,
  Corporate = 5,
}

export const clientTypeOptions = Object.entries(ClientTypeEnum)
  .filter(([key, value]) => typeof value === 'number')
  .map(([key, value]) => ({
    label: key,
    value: value as number,
  }));
